// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "dataannotations/v1/dataannotations.proto" (package "dataannotations.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private data annotations RPCs and protos
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FlatTensors } from "../../service/mlmodel/v1/mlmodel";
import { Annotations } from "../../app/data/v1/data";
import { BinaryData } from "../../app/data/v1/data";
import { Timestamp } from "../../google/protobuf/timestamp";
import { DataType } from "../../app/datasync/v1/data_sync";
/**
 * @generated from protobuf message dataannotations.v1.GetBoundingBoxLabelsForOrgRequest
 */
export interface GetBoundingBoxLabelsForOrgRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string last = 2;
     */
    last: string;
}
/**
 * @generated from protobuf message dataannotations.v1.GetBoundingBoxLabelsForOrgResponse
 */
export interface GetBoundingBoxLabelsForOrgResponse {
    /**
     * @generated from protobuf field: repeated string labels = 1;
     */
    labels: string[];
}
/**
 * @generated from protobuf message dataannotations.v1.AddTagsForResourceRequest
 */
export interface AddTagsForResourceRequest {
    /**
     * @generated from protobuf field: repeated string tags = 1;
     */
    tags: string[];
    /**
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string location_id = 3;
     */
    locationId: string;
    /**
     * @generated from protobuf field: string robot_id = 4;
     */
    robotId: string;
}
/**
 * @generated from protobuf message dataannotations.v1.AddTagsForResourceResponse
 */
export interface AddTagsForResourceResponse {
}
/**
 * @generated from protobuf message dataannotations.v1.GetTagsForOrgRequest
 */
export interface GetTagsForOrgRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string last = 3;
     */
    last: string;
    /**
     * @generated from protobuf field: viam.app.datasync.v1.DataType data_type = 4;
     */
    dataType: DataType;
}
/**
 * @generated from protobuf message dataannotations.v1.GetTagsForOrgResponse
 */
export interface GetTagsForOrgResponse {
    /**
     * @generated from protobuf field: repeated string tags = 1;
     */
    tags: string[];
}
/**
 * @generated from protobuf message dataannotations.v1.SourceType
 */
export interface SourceType {
    /**
     * @generated from protobuf oneof: metadata_type
     */
    metadataType: {
        oneofKind: "cloudInferenceMetadata";
        /**
         * @generated from protobuf field: dataannotations.v1.CloudInferenceMetadata cloud_inference_metadata = 1;
         */
        cloudInferenceMetadata: CloudInferenceMetadata;
    } | {
        oneofKind: "robotInferenceMetadata";
        /**
         * @generated from protobuf field: dataannotations.v1.RobotInferenceMetadata robot_inference_metadata = 2;
         */
        robotInferenceMetadata: RobotInferenceMetadata;
    } | {
        oneofKind: "userAddedMetadata";
        /**
         * @generated from protobuf field: dataannotations.v1.UserAddedMetadata user_added_metadata = 3;
         */
        userAddedMetadata: UserAddedMetadata;
    } | {
        oneofKind: "dataManagerConfigMetadata";
        /**
         * @generated from protobuf field: dataannotations.v1.DataManagerConfigMetadata data_manager_config_metadata = 4;
         */
        dataManagerConfigMetadata: DataManagerConfigMetadata;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message dataannotations.v1.CloudInferenceMetadata
 */
export interface CloudInferenceMetadata {
    /**
     * @generated from protobuf field: string registry_id = 1;
     */
    registryId: string;
    /**
     * @generated from protobuf field: string registry_version = 2;
     */
    registryVersion: string;
    /**
     * @generated from protobuf field: string dataset_id = 3;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string delphi_version = 4;
     */
    delphiVersion: string;
    /**
     * @generated from protobuf field: string inference_job_id = 5;
     */
    inferenceJobId: string;
    /**
     * @generated from protobuf field: bool is_accepted = 6;
     */
    isAccepted: boolean;
}
/**
 * @generated from protobuf message dataannotations.v1.RobotInferenceMetadata
 */
export interface RobotInferenceMetadata {
    /**
     * @generated from protobuf field: string registry_id = 1;
     */
    registryId: string;
    /**
     * @generated from protobuf field: string registry_version = 2;
     */
    registryVersion: string;
}
/**
 * @generated from protobuf message dataannotations.v1.UserAddedMetadata
 */
export interface UserAddedMetadata {
}
/**
 * @generated from protobuf message dataannotations.v1.DataManagerConfigMetadata
 */
export interface DataManagerConfigMetadata {
}
/**
 * @generated from protobuf message dataannotations.v1.AnnotationMetadata
 */
export interface AnnotationMetadata {
    /**
     * @generated from protobuf field: dataannotations.v1.SourceType source_type = 1;
     */
    sourceType?: SourceType;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_updated = 3;
     */
    lastUpdated?: Timestamp;
}
/**
 * @generated from protobuf message dataannotations.v1.BinaryDataWithCandidateInferences
 */
export interface BinaryDataWithCandidateInferences {
    /**
     * @generated from protobuf field: viam.app.data.v1.BinaryData binary_data = 1;
     */
    binaryData?: BinaryData;
    /**
     * @generated from protobuf field: viam.app.data.v1.Annotations candidate_inferences = 2;
     */
    candidateInferences?: Annotations;
}
/**
 * @generated from protobuf message dataannotations.v1.BinaryDataByDatasetIDRequest
 */
export interface BinaryDataByDatasetIDRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string last = 2;
     */
    last: string;
    /**
     * @generated from protobuf field: uint64 limit = 3;
     */
    limit: string;
    /**
     * @generated from protobuf field: bool include_binary = 4;
     */
    includeBinary: boolean;
    /**
     * @generated from protobuf field: string inference_job_id = 5;
     */
    inferenceJobId: string;
    /**
     * @generated from protobuf field: bool count_only = 6;
     */
    countOnly: boolean;
    /**
     * @generated from protobuf field: repeated string mime_type = 7;
     */
    mimeType: string[];
    /**
     * @generated from protobuf field: bool pending_review_only = 8;
     */
    pendingReviewOnly: boolean;
}
/**
 * @generated from protobuf message dataannotations.v1.BinaryDataByDatasetIDResponse
 */
export interface BinaryDataByDatasetIDResponse {
    /**
     * @generated from protobuf field: repeated dataannotations.v1.BinaryDataWithCandidateInferences data = 1;
     */
    data: BinaryDataWithCandidateInferences[];
    /**
     * @generated from protobuf field: string last = 2;
     */
    last: string;
    /**
     * @generated from protobuf field: uint64 count = 3;
     */
    count: string;
}
/**
 * @generated from protobuf message dataannotations.v1.SaveInferenceWithMetadataRequest
 */
export interface SaveInferenceWithMetadataRequest {
    /**
     * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensors output_tensors = 1;
     */
    outputTensors?: FlatTensors;
    /**
     * @generated from protobuf field: viam.app.data.v1.Annotations annotations = 2;
     */
    annotations?: Annotations;
    /**
     * @generated from protobuf field: string binary_data_id = 3;
     */
    binaryDataId: string;
    /**
     * @generated from protobuf field: string registry_item_id = 4;
     */
    registryItemId: string;
    /**
     * @generated from protobuf field: string registry_item_version = 5;
     */
    registryItemVersion: string;
    /**
     * @generated from protobuf field: string inference_job_id = 6;
     */
    inferenceJobId: string;
    /**
     * @generated from protobuf field: string dataset_id = 7;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string delphi_version = 8;
     */
    delphiVersion: string;
    /**
     * @generated from protobuf field: bool single_inference = 9;
     */
    singleInference: boolean;
}
/**
 * @generated from protobuf message dataannotations.v1.SaveInferenceWithMetadataResponse
 */
export interface SaveInferenceWithMetadataResponse {
    /**
     * @generated from protobuf field: string inference_job_id = 2;
     */
    inferenceJobId: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.Annotations candidate_inferences = 1;
     */
    candidateInferences?: Annotations;
}
/**
 * @generated from protobuf message dataannotations.v1.GetCandidateInferencesRequest
 */
export interface GetCandidateInferencesRequest {
    /**
     * @generated from protobuf field: string binary_data_id = 1;
     */
    binaryDataId: string;
    /**
     * @generated from protobuf field: string inference_job_id = 2;
     */
    inferenceJobId: string;
}
/**
 * @generated from protobuf message dataannotations.v1.GetCandidateInferencesResponse
 */
export interface GetCandidateInferencesResponse {
    /**
     * @generated from protobuf field: viam.app.data.v1.Annotations annotations = 1;
     */
    annotations?: Annotations;
}
/**
 * @generated from protobuf message dataannotations.v1.ReviewInferencesRequest
 */
export interface ReviewInferencesRequest {
    /**
     * @generated from protobuf field: string binary_data_id = 1;
     */
    binaryDataId: string;
    /**
     * @generated from protobuf field: string inference_job_id = 2;
     */
    inferenceJobId: string;
    /**
     * Passing in annotation_id is optional, if not provided, all annotations will be accepted or rejected.
     *
     * @generated from protobuf field: string annotation_id = 4;
     */
    annotationId: string;
    /**
     * @generated from protobuf field: bool accept = 5;
     */
    accept: boolean;
}
/**
 * @generated from protobuf message dataannotations.v1.ReviewInferencesResponse
 */
export interface ReviewInferencesResponse {
}
/**
 * @generated from protobuf message dataannotations.v1.RejectInferencesForJobRequest
 */
export interface RejectInferencesForJobRequest {
    /**
     * @generated from protobuf field: string inference_job_id = 1;
     */
    inferenceJobId: string;
}
/**
 * @generated from protobuf message dataannotations.v1.RejectInferencesForJobResponse
 */
export interface RejectInferencesForJobResponse {
}
/**
 * @generated from protobuf message dataannotations.v1.GetLabelCountsForDatasetRequest
 */
export interface GetLabelCountsForDatasetRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: dataannotations.v1.AnnotationType annotation_type = 2;
     */
    annotationType: AnnotationType;
    /**
     * @generated from protobuf field: uint32 limit = 3;
     */
    limit: number;
}
/**
 * @generated from protobuf message dataannotations.v1.GetLabelCountsForDatasetResponse
 */
export interface GetLabelCountsForDatasetResponse {
    /**
     * Image counts gives the number of images that have at least one annotation with the given label.
     *
     * @generated from protobuf field: map<string, int32> image_counts = 1;
     */
    imageCounts: {
        [key: string]: number;
    };
    /**
     * Label counts gives the total number of annotations with the given label.
     *
     * @generated from protobuf field: map<string, int32> label_counts = 2;
     */
    labelCounts: {
        [key: string]: number;
    };
}
/**
 * @generated from protobuf message dataannotations.v1.RemoveClassificationFromBinaryDataByIDRequest
 */
export interface RemoveClassificationFromBinaryDataByIDRequest {
    /**
     * @generated from protobuf field: string binary_data_id = 1;
     */
    binaryDataId: string;
    /**
     * @generated from protobuf field: string annotation_id = 2;
     */
    annotationId: string;
}
/**
 * @generated from protobuf message dataannotations.v1.RemoveClassificationFromBinaryDataByIDResponse
 */
export interface RemoveClassificationFromBinaryDataByIDResponse {
}
/**
 * @generated from protobuf enum dataannotations.v1.AnnotationType
 */
export enum AnnotationType {
    /**
     * @generated from protobuf enum value: ANNOTATION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ANNOTATION_TYPE_CLASSIFICATION = 1;
     */
    CLASSIFICATION = 1,
    /**
     * @generated from protobuf enum value: ANNOTATION_TYPE_BOUNDING_BOX = 2;
     */
    BOUNDING_BOX = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class GetBoundingBoxLabelsForOrgRequest$Type extends MessageType<GetBoundingBoxLabelsForOrgRequest> {
    constructor() {
        super("dataannotations.v1.GetBoundingBoxLabelsForOrgRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.GetBoundingBoxLabelsForOrgRequest
 */
export const GetBoundingBoxLabelsForOrgRequest = new GetBoundingBoxLabelsForOrgRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBoundingBoxLabelsForOrgResponse$Type extends MessageType<GetBoundingBoxLabelsForOrgResponse> {
    constructor() {
        super("dataannotations.v1.GetBoundingBoxLabelsForOrgResponse", [
            { no: 1, name: "labels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.GetBoundingBoxLabelsForOrgResponse
 */
export const GetBoundingBoxLabelsForOrgResponse = new GetBoundingBoxLabelsForOrgResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddTagsForResourceRequest$Type extends MessageType<AddTagsForResourceRequest> {
    constructor() {
        super("dataannotations.v1.AddTagsForResourceRequest", [
            { no: 1, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "robot_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.AddTagsForResourceRequest
 */
export const AddTagsForResourceRequest = new AddTagsForResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddTagsForResourceResponse$Type extends MessageType<AddTagsForResourceResponse> {
    constructor() {
        super("dataannotations.v1.AddTagsForResourceResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.AddTagsForResourceResponse
 */
export const AddTagsForResourceResponse = new AddTagsForResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTagsForOrgRequest$Type extends MessageType<GetTagsForOrgRequest> {
    constructor() {
        super("dataannotations.v1.GetTagsForOrgRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "last", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "data_type", kind: "enum", T: () => ["viam.app.datasync.v1.DataType", DataType, "DATA_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.GetTagsForOrgRequest
 */
export const GetTagsForOrgRequest = new GetTagsForOrgRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTagsForOrgResponse$Type extends MessageType<GetTagsForOrgResponse> {
    constructor() {
        super("dataannotations.v1.GetTagsForOrgResponse", [
            { no: 1, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.GetTagsForOrgResponse
 */
export const GetTagsForOrgResponse = new GetTagsForOrgResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SourceType$Type extends MessageType<SourceType> {
    constructor() {
        super("dataannotations.v1.SourceType", [
            { no: 1, name: "cloud_inference_metadata", kind: "message", oneof: "metadataType", T: () => CloudInferenceMetadata },
            { no: 2, name: "robot_inference_metadata", kind: "message", oneof: "metadataType", T: () => RobotInferenceMetadata },
            { no: 3, name: "user_added_metadata", kind: "message", oneof: "metadataType", T: () => UserAddedMetadata },
            { no: 4, name: "data_manager_config_metadata", kind: "message", oneof: "metadataType", T: () => DataManagerConfigMetadata }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.SourceType
 */
export const SourceType = new SourceType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CloudInferenceMetadata$Type extends MessageType<CloudInferenceMetadata> {
    constructor() {
        super("dataannotations.v1.CloudInferenceMetadata", [
            { no: 1, name: "registry_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "registry_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "delphi_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "inference_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_accepted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.CloudInferenceMetadata
 */
export const CloudInferenceMetadata = new CloudInferenceMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RobotInferenceMetadata$Type extends MessageType<RobotInferenceMetadata> {
    constructor() {
        super("dataannotations.v1.RobotInferenceMetadata", [
            { no: 1, name: "registry_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "registry_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.RobotInferenceMetadata
 */
export const RobotInferenceMetadata = new RobotInferenceMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAddedMetadata$Type extends MessageType<UserAddedMetadata> {
    constructor() {
        super("dataannotations.v1.UserAddedMetadata", []);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.UserAddedMetadata
 */
export const UserAddedMetadata = new UserAddedMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataManagerConfigMetadata$Type extends MessageType<DataManagerConfigMetadata> {
    constructor() {
        super("dataannotations.v1.DataManagerConfigMetadata", []);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.DataManagerConfigMetadata
 */
export const DataManagerConfigMetadata = new DataManagerConfigMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AnnotationMetadata$Type extends MessageType<AnnotationMetadata> {
    constructor() {
        super("dataannotations.v1.AnnotationMetadata", [
            { no: 1, name: "source_type", kind: "message", T: () => SourceType },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "last_updated", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.AnnotationMetadata
 */
export const AnnotationMetadata = new AnnotationMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BinaryDataWithCandidateInferences$Type extends MessageType<BinaryDataWithCandidateInferences> {
    constructor() {
        super("dataannotations.v1.BinaryDataWithCandidateInferences", [
            { no: 1, name: "binary_data", kind: "message", T: () => BinaryData },
            { no: 2, name: "candidate_inferences", kind: "message", T: () => Annotations }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.BinaryDataWithCandidateInferences
 */
export const BinaryDataWithCandidateInferences = new BinaryDataWithCandidateInferences$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BinaryDataByDatasetIDRequest$Type extends MessageType<BinaryDataByDatasetIDRequest> {
    constructor() {
        super("dataannotations.v1.BinaryDataByDatasetIDRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "limit", kind: "scalar", T: 4 /*ScalarType.UINT64*/ },
            { no: 4, name: "include_binary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "inference_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "count_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "mime_type", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "pending_review_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.BinaryDataByDatasetIDRequest
 */
export const BinaryDataByDatasetIDRequest = new BinaryDataByDatasetIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BinaryDataByDatasetIDResponse$Type extends MessageType<BinaryDataByDatasetIDResponse> {
    constructor() {
        super("dataannotations.v1.BinaryDataByDatasetIDResponse", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryDataWithCandidateInferences },
            { no: 2, name: "last", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.BinaryDataByDatasetIDResponse
 */
export const BinaryDataByDatasetIDResponse = new BinaryDataByDatasetIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveInferenceWithMetadataRequest$Type extends MessageType<SaveInferenceWithMetadataRequest> {
    constructor() {
        super("dataannotations.v1.SaveInferenceWithMetadataRequest", [
            { no: 1, name: "output_tensors", kind: "message", T: () => FlatTensors },
            { no: 2, name: "annotations", kind: "message", T: () => Annotations },
            { no: 3, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "registry_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "registry_item_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "inference_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "delphi_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "single_inference", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.SaveInferenceWithMetadataRequest
 */
export const SaveInferenceWithMetadataRequest = new SaveInferenceWithMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveInferenceWithMetadataResponse$Type extends MessageType<SaveInferenceWithMetadataResponse> {
    constructor() {
        super("dataannotations.v1.SaveInferenceWithMetadataResponse", [
            { no: 2, name: "inference_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 1, name: "candidate_inferences", kind: "message", T: () => Annotations }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.SaveInferenceWithMetadataResponse
 */
export const SaveInferenceWithMetadataResponse = new SaveInferenceWithMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCandidateInferencesRequest$Type extends MessageType<GetCandidateInferencesRequest> {
    constructor() {
        super("dataannotations.v1.GetCandidateInferencesRequest", [
            { no: 1, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "inference_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.GetCandidateInferencesRequest
 */
export const GetCandidateInferencesRequest = new GetCandidateInferencesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCandidateInferencesResponse$Type extends MessageType<GetCandidateInferencesResponse> {
    constructor() {
        super("dataannotations.v1.GetCandidateInferencesResponse", [
            { no: 1, name: "annotations", kind: "message", T: () => Annotations }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.GetCandidateInferencesResponse
 */
export const GetCandidateInferencesResponse = new GetCandidateInferencesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReviewInferencesRequest$Type extends MessageType<ReviewInferencesRequest> {
    constructor() {
        super("dataannotations.v1.ReviewInferencesRequest", [
            { no: 1, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "inference_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "annotation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "accept", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.ReviewInferencesRequest
 */
export const ReviewInferencesRequest = new ReviewInferencesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReviewInferencesResponse$Type extends MessageType<ReviewInferencesResponse> {
    constructor() {
        super("dataannotations.v1.ReviewInferencesResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.ReviewInferencesResponse
 */
export const ReviewInferencesResponse = new ReviewInferencesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectInferencesForJobRequest$Type extends MessageType<RejectInferencesForJobRequest> {
    constructor() {
        super("dataannotations.v1.RejectInferencesForJobRequest", [
            { no: 1, name: "inference_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.RejectInferencesForJobRequest
 */
export const RejectInferencesForJobRequest = new RejectInferencesForJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectInferencesForJobResponse$Type extends MessageType<RejectInferencesForJobResponse> {
    constructor() {
        super("dataannotations.v1.RejectInferencesForJobResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.RejectInferencesForJobResponse
 */
export const RejectInferencesForJobResponse = new RejectInferencesForJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLabelCountsForDatasetRequest$Type extends MessageType<GetLabelCountsForDatasetRequest> {
    constructor() {
        super("dataannotations.v1.GetLabelCountsForDatasetRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "annotation_type", kind: "enum", T: () => ["dataannotations.v1.AnnotationType", AnnotationType, "ANNOTATION_TYPE_"] },
            { no: 3, name: "limit", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.GetLabelCountsForDatasetRequest
 */
export const GetLabelCountsForDatasetRequest = new GetLabelCountsForDatasetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLabelCountsForDatasetResponse$Type extends MessageType<GetLabelCountsForDatasetResponse> {
    constructor() {
        super("dataannotations.v1.GetLabelCountsForDatasetResponse", [
            { no: 1, name: "image_counts", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } },
            { no: 2, name: "label_counts", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.GetLabelCountsForDatasetResponse
 */
export const GetLabelCountsForDatasetResponse = new GetLabelCountsForDatasetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveClassificationFromBinaryDataByIDRequest$Type extends MessageType<RemoveClassificationFromBinaryDataByIDRequest> {
    constructor() {
        super("dataannotations.v1.RemoveClassificationFromBinaryDataByIDRequest", [
            { no: 1, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "annotation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.RemoveClassificationFromBinaryDataByIDRequest
 */
export const RemoveClassificationFromBinaryDataByIDRequest = new RemoveClassificationFromBinaryDataByIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveClassificationFromBinaryDataByIDResponse$Type extends MessageType<RemoveClassificationFromBinaryDataByIDResponse> {
    constructor() {
        super("dataannotations.v1.RemoveClassificationFromBinaryDataByIDResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message dataannotations.v1.RemoveClassificationFromBinaryDataByIDResponse
 */
export const RemoveClassificationFromBinaryDataByIDResponse = new RemoveClassificationFromBinaryDataByIDResponse$Type();
/**
 * @generated ServiceType for protobuf service dataannotations.v1.InternalDataAnnotationsService
 */
export const InternalDataAnnotationsService = new ServiceType("dataannotations.v1.InternalDataAnnotationsService", [
    { name: "GetBoundingBoxLabelsForOrg", options: {}, I: GetBoundingBoxLabelsForOrgRequest, O: GetBoundingBoxLabelsForOrgResponse },
    { name: "AddTagsForResource", options: {}, I: AddTagsForResourceRequest, O: AddTagsForResourceResponse },
    { name: "GetTagsForOrg", options: {}, I: GetTagsForOrgRequest, O: GetTagsForOrgResponse },
    { name: "BinaryDataByDatasetID", options: {}, I: BinaryDataByDatasetIDRequest, O: BinaryDataByDatasetIDResponse },
    { name: "SaveInferenceWithMetadata", options: {}, I: SaveInferenceWithMetadataRequest, O: SaveInferenceWithMetadataResponse },
    { name: "GetCandidateInferences", options: {}, I: GetCandidateInferencesRequest, O: GetCandidateInferencesResponse },
    { name: "ReviewInferences", options: {}, I: ReviewInferencesRequest, O: ReviewInferencesResponse },
    { name: "RejectInferencesForJob", options: {}, I: RejectInferencesForJobRequest, O: RejectInferencesForJobResponse },
    { name: "GetLabelCountsForDataset", options: {}, I: GetLabelCountsForDatasetRequest, O: GetLabelCountsForDatasetResponse },
    { name: "RemoveClassificationFromBinaryDataByID", options: {}, I: RemoveClassificationFromBinaryDataByIDRequest, O: RemoveClassificationFromBinaryDataByIDResponse }
]);
